var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-result-chart"},_vm._l((_vm.quizzes),function(quiz,index){return _c('div',{key:quiz.id,staticClass:"quiz-result-chart__item",class:_vm.getChartClassNames(quiz)},[_vm._v(" "+_vm._s((index + 1))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }